import { Box, LinearProgress, Typography } from '@mui/material';

export default function ProgressBar({ activeStep  , totalSteps }) {

    let progress = totalSteps === 0 ? 0 : ( (totalSteps - activeStep)  / totalSteps) * 100;

    return (
        <Box sx={{marginBottom:{xs:'12px',sm:'12px',md:'24px'}}}>
            <LinearProgress variant="determinate" value={progress} sx={{
                backgroundColor: '#fff',
                height: '8px',
                '& .MuiLinearProgress-bar': {
                    backgroundColor: '#0BC1B6',
                },
            }} />
        </Box>
    );
}
